import { render } from "./ListadoVentas.vue?vue&type=template&id=33714abd&scoped=true"
import script from "./ListadoVentas.vue?vue&type=script&lang=js"
export * from "./ListadoVentas.vue?vue&type=script&lang=js"

import "./ListadoVentas.vue?vue&type=style&index=0&id=33714abd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33714abd"]])

export default __exports__